export enum TypeModificationEnum {
  AJOUT,
  MODIFICATION,
}
